import type { ReactNode } from "react";

/**
 * Shared empty / loading / error / skeleton surfaces for flow screens.
 * Shimmer respects prefers-reduced-motion via CSS.
 */
export function FlowEmpty({
  message,
  testId,
  action,
}: {
  message: string;
  testId?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flow-empty" data-testid={testId ?? "flow-empty"} role="status">
      <p>{message}</p>
      {action}
    </div>
  );
}

export function FlowSkeleton({ label = "Loading" }: { label?: string }) {
  return (
    <div className="flow-skeleton" aria-busy="true" aria-label={label}>
      <div className="skeleton-shimmer" />
    </div>
  );
}

export function ConstraintChips({
  labels,
  emptyLabel = "No limits",
  testId = "constraint-chips",
}: {
  labels: string[];
  emptyLabel?: string;
  testId?: string;
}) {
  return (
    <ul className="constraint-chips" data-testid={testId} aria-label="Challenge limits">
      {labels.length === 0 ? (
        <li className="constraint-chip muted">{emptyLabel}</li>
      ) : (
        labels.map((label) => (
          <li key={label} className="constraint-chip">
            {label}
          </li>
        ))
      )}
    </ul>
  );
}
